<template>
  <div>
    <list v-show="showList" ref="listComponent" @onEdit="handleEdit"></list>
  </div>
</template>

<script>

// 动态切换组件
import List from './CustomerTrashList'

export default {
  name: 'CustomerTrashPage',
  components: {
    List
  },
  data () {
    return {
      record: '',
      // 是否显示List
      showList: true
    }
  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.showList = false
    },
    handleGoBack () {
      this.record = ''
      this.$refs.listComponent.refreshCurrentPage()
      this.showList = true
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.showList = true
    }
  }
}
</script>
